// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"168":"2704ae15","283":"4bb3bc00","347":"3100445e","732":"ac8cdce2","977":"3d192f15"}[chunkId] + ".chunk.js";
};